import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Group } from '../models/group.model';

const WORKPLACE_API_URL = `/api/v3/workplace`;

@Injectable()
export class WorkplaceBackend {
  constructor(private http: HttpClient) {}

  create(body: { code: string; email: string; redirect_uri: string }) {
    return this.http.post(`${WORKPLACE_API_URL}/create`, body);
  }

  getGroups() {
    return this.http.get(`${WORKPLACE_API_URL}/groups`);
  }

  groupsAssociate(group: Group) {
    return this.http.post(`${WORKPLACE_API_URL}/groups/associate`, group);
  }

  getAccountVerify() {
    return this.http.get(`${WORKPLACE_API_URL}/account/verify`);
  }

  patchAccount(update: { [key: string]: any }) {
    return this.http.patch(`${WORKPLACE_API_URL}/account`, update);
  }

  postAccountVerify(body: { [key: string]: any }) {
    return this.http.post(`${WORKPLACE_API_URL}/account/verify`, body);
  }

  postLoginToken(body: { email: string; state?: string }) {
    return this.http.post(`${WORKPLACE_API_URL}/login-token`, body);
  }

  groupPostInstall(group: Group) {
    return this.http.get(`${WORKPLACE_API_URL}/${group._id}/post-install`);
  }
}
